module.exports = __webpack_public_path__ + "static/index/img/baikal-1008.5b1dc8d6.jpg";